<style>
.enc-col {
  font-weight: bold;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Dispositivos</b-card-header>
      <b-card-body>
        <div v-if="this.DispositivosLenght ==0" class="text-center">
          <div>No se encontraron registros</div>
          <img src="/img/ic_no_resultado.png" style="width: 200px;" />
        </div>
        <div v-else>
          <div class="row">
            <div class="col-4 text-left enc-col"><label style="margin-left:65px; font-weight: bold; font-size:17px">Estado</label></div>
            <div class="col-4 text-center enc-col">Número de Serie</div>
            <div class="col-4 text-center enc-col">Fecha de Alta</div>
          </div>
          <div
            class="row"
            v-for="item in Dispositivos"
            v-bind:key="item.DeviceID"
            style="padding-bottom: 15px; padding-top: 15px; border-bottom: 1px solid #d6d4d4; cursor: pointer"
          >
            <div v-if="item.Enabled" class="col-4 text-left">
              <i class="fa fa-check-circle fa-fw" style="color:green;margin-left:40px"></i>Habilitado
            </div>
            <div v-else class="col-4 text-left">
              <i class="fa fa-times-circle fa-fw" style="color:red;margin-left:40px"></i>Deshabilitado
            </div>
            <div class="col-4 text-center">{{item.AccessoryIdentifier}}</div>
            <div class="col-4 text-center">{{item.FormattedCommerceAssociationDate}}</div>
          </div>
        </div>

        <br />
        <div class="row" style="margin-bottom: 10px" v-if="$store.getters.HabilitarAgregarDispositivo">
          <div class="col-md-12 text-center">
            <button class="btn btn-success" type="button" :disabled="!IsAddDeviceEnabled" @click="agregarDispositivo()">
              <i class="fa fa-plus-circle fa-fw"></i>Agregar Dispositivo
            </button>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  name: "MisDispositivos",
  data() {
    return {
      Errors: [],
      Dispositivos: [],
      DispositivosLenght: 0,
      AcceptTermsConditions: false,
      IsAddDeviceEnabled: false
    };
  },
  methods: {
    agregarDispositivo() {
      let context = this;
      this.$router.push({name: "AgregarDispositivo", params: { AcceptTermsAndConditions: context.AcceptTermsConditions }});
    },
    getDevices() {
      let context = this;
      axiosHelpers.axiosGet(
        "Commerce/GetAssignedAccessoriesByCommerce",
        {},
        this,
        function(response) {
          context.Dispositivos = response.ResponseVM.Items;
          context.DispositivosLenght = context.Dispositivos.length;
          context.AcceptTermsConditions = response.ResponseVM.AcceptTermsAndConditions;
          context.IsAddDeviceEnabled = response.ResponseVM.IsAddEnabled;
        }
      );
    },
    goBack() {
      this.$router.push("SmartPost");
    }
  },
  mounted() {
    this.getDevices();
  }
};
</script>